<div
  class="alert alert-warning"
  *ngIf="!canManage"
>
  You are not the owner of this template. Restrictions apply.
</div>
<quick-preview-panel
  *ngIf="form"
  [heading]="isNew ? (cloningFromSource? 'Clone Template' :'Register New Template') : 'Edit Template'"
  [color]="form.valid ? 'primary' : 'warn'"
>
  <div class="p-3 pt-4" [formGroup]="form" *ngIf="(isNew || existing)">
    <div class="row p-0 m-0">
      <input type="hidden" formControlName="id">
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Name</mat-label>
          <input type="text" matInput class="d-block"
                 formControlName="name">
          <mat-error *ngIf="form.get('name')!.hasError('required')">
            Required field
          </mat-error>
          <mat-error *ngIf="form.get('name')!.hasError('exists')">
            Already exists
          </mat-error>
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Assistant</mat-label>
          <mat-select formControlName="assistantId">
            <mat-option *ngFor="let c of chatbots" [value]="c.id">{{c.id}} - {{c.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-6 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Description</mat-label>
          <input type="text" matInput class="d-block"
                 formControlName="description">
        </mat-form-field>
      </div>
    </div>
    <div class="d-block me-2" formArrayName="messages">
      <div *ngFor="let fg of messagesArrayControls; let index = index" [formGroup]="fg">
        <div class="row p-0 m-0">
          <div class="col-12 col-md-4 col-lg-2 m-0 p-0 pe-2">
            <mat-form-field class="d-block">
            <mat-label>Message Type</mat-label>
            <mat-select class="d-block" [formControl]="castToFormControl(fg.controls['role'])">
              <mat-option *ngFor="let mt of messageTypes" [value]="mt">{{mt}}</mat-option>
            </mat-select>
          </mat-form-field>
          </div>
          <div class="col-12 col-md-8 col-lg-10 m-0 p-0">
            <mat-form-field class="d-block">
            <mat-label>Message Text</mat-label>
            <textarea
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="500"
              matInput class="d-block" rows="5"
              placeholder="Your background story to be passed as part of the template..."
              [formControl]="castToFormControl(fg.controls['message'])"></textarea>
            <mat-error *ngIf="fg.controls['message'].hasError('required')">
              Required field
            </mat-error>
          </mat-form-field>
          </div>
        </div>
        <div class="row m-0 p-0 mb-2">
          <div class="col-12 col-md-4 col-lg-2 m-0 p-0 pe-2"></div>
          <div class="col-12 col-md-4 col-lg-8 m-0 p-0">
            <div *ngIf="messageWarnings[index]" class="alert alert-warning fw-light font-size-12 p-2">
            {{messageWarnings[index]}}
          </div>
            <div *ngIf="availableContextVars && availableContextVars.length" class="fw-light font-size-12">
            You can use one of the following vars:
            <span *ngFor="let v of availableContextVars; let last=last">
              <span
                [ngClass]="{'text-decoration-line-through fw-bold': messageVars[index] && messageVars[index].includes(v)}"
              >{{v}}</span><span *ngIf="!last">, </span>
            </span>
          </div>
          </div>
          <div class="col-12 col-md-4 col-lg-2 m-0 p-0">
            <actions-container>
              <button *ngIf="canManage" mat-raised-button color="warn" (click)="deleteControlAtIndex(index)">
                Delete Message
              </button>
            </actions-container>
          </div>
        </div>
      </div>
      <actions-container [ngClass]="'mb-4'">
        <button *ngIf="canManage" mat-raised-button color="primary" (click)="addMessageControl()">Add Message</button>
      </actions-container>
    </div>
    <actions-container [ngClass]="'me-2'">
      <back-button></back-button>
      <button
        *ngIf="canManage"
        [disabled]="!form.valid"
        color="primary"
        class="mx-1"
        mat-raised-button
        (click)="save()"
      >
        <mat-icon class="valign-middle">save</mat-icon>
        Save
      </button>
    </actions-container>
  </div>

</quick-preview-panel>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<error-panel ngClass="my-4" [error]="error"></error-panel>

